
// Open guide from guide button
$('.customise-section .guide-btn').off().click( function() {
  $(this).closest('.customise-section').find('.product-guide-drawer').addClass('active');
  $(this).closest('.customise-section').find('.product-guide-drawer .drawer-header .close-btn').addClass('highlight'); // One-time highlight of close button (mobile only)
  handleFixedElements('hide');
});

// Open stone guide from custom link
$("a[href*='?stone-guide']").click( function(e) {
  e.preventDefault();
  $('.drawer.birthstone-guide').addClass('active');
  $('.drawer.birthstone-guide').find('.drawer-header .close-btn').addClass('highlight'); // One-time highlight of close button (mobile only)
});

// Open starsign guide from custom link
$("a[href*='?starsign-guide']").click( function(e) {
  e.preventDefault();
  $('.drawer.starsign-guide').addClass('active');
  $('.drawer.starsign-guide').find('.drawer-header .close-btn').addClass('highlight'); // One-time highlight of close button (mobile only)
});

// Open zodiac guide from custom link
$("a[href*='?zodiac-guide']").click( function(e) {
  e.preventDefault();
  $('.drawer.starsign-guide').addClass('active');
  $('.drawer.starsign-guide').find('.drawer-header .close-btn').addClass('highlight'); // One-time highlight of close button (mobile only)
});

// Close guide on enter ring-sizer
$('.customise-ring-size .ring-size-guide').find('#ring-sizer-trigger').click( function() {
  $('.customise-ring-size .ring-size-guide').removeClass('active');
});

// Close guide on add-to-bag-direct-product
$('.product-guide-drawer').find('.add-to-bag-direct-product').click(function(e) {
  $('.product-guide-drawer').removeClass('active');
}); // end click Add-to-bag
